import { cx } from '@emotion/css';
import { FC, ReactNode } from 'react';

export type PageTitleType = 'page' | 'subpage';

export interface PageTitleProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  type?: PageTitleType;
}

export const PageTitle: FC<React.PropsWithChildren<PageTitleProps>> = ({ children, type = 'page', className }) => {
  return (
    <div
      className={cx(
        className,
        'inline-flex w-full flex-col',
        type === 'page' ? 'stihl-text-h1-mobile md:stihl-text-h1-desktop' : 'stihl-text-h2-mobile md:stihl-text-h2-desktop'
      )}
      data-testid="page-title"
    >
      <div className="z-10 truncate whitespace-pre-wrap">{children}</div>
      <div>&#402;</div>
    </div>
  );
};
